import { NotifyHelper } from "../../../helpers/toast";
import { eDanhSachMoMonActionsObj } from "../../action-types/lop-tin-chi/IDanhSachMoMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhSachMoMonActions = {
  ...generateActions(eDanhSachMoMonActionsObj, "DANH_SACH_MO_MON"),
  ...generateActionForKey(
    eDanhSachMoMonActionsObj,
    "DANH_SACH_MO_MON",
    "EXPORT_EXCEL_SUCCESS",
    (m) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eDanhSachMoMonActionsObj,
    "DANH_SACH_MO_MON",
    "EXPORT_EXCEL_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
